export const extractBotStrId = (currentUrl) => {
    let botStrIdRegex = /\/[A-Z0-9]{4}-[A-Z0-9]{3}-[A-Z0-9]{4}\//;
    let regexMatchResult = currentUrl.match(botStrIdRegex);
    if (regexMatchResult == null) {
        return null;
    }
    let botStrId = regexMatchResult[0].substr(1);
    botStrId = botStrId.slice(0, -1);
    return botStrId;
}